export default "__VITE_PUBLIC_ASSET__07919634__"